import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPlugin from './material-dashboard'

// Plugins
import App from './App.vue'

// router setup
import routes from './routes/routes'

// store setup
import store from './store';

import LogService from "@/services/LogService";
import UserService from "@/services/UserService";
import InitService from "@/services/InitService";

import VTooltip from 'v-tooltip'

// plugin setup
Vue.use(VueRouter)
Vue.use(DashboardPlugin)
Vue.use(VTooltip)

window.logoutUrl = process.env.VUE_APP_LOGIN_URL;

// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    linkExactActiveClass: 'nav-item active',
});


router.beforeEach((to, from, next) => {
    let urlParams = new URLSearchParams(window.location.search);
    let customerSSO = urlParams.get('sso');
    if(customerSSO)
    {
        LogService.SendSSOChallenge({ partnerName: customerSSO }).then(response => 
        {
            if(response.data)
            {
                window.location.href = response.data;
                return;
            }
        });
    }
    if (to.path.startsWith('/id_token=')) {

        let params = new URLSearchParams(to.path.substring(1)); // remove the starting slash
        localStorage.setItem('token', params.get('id_token'));

        LogService.TrySetLogoutUrl();
        LogService.SendLogAction({ type: "Login" }).then(() => {
            window.location.href = '/';
        });
        /*next({
            path: '/'
        });*/
/*
        Api().get('/api/v2/userexists').then(function(response) {

            if (response.data) {

                // this.loadCustomBranding();
                // this.$store.dispatch('loadInitialState');
                // this.$store.dispatch('loadCarousels');
                // this.$store.dispatch('getUser');
                // this.$store.dispatch('getUserSetup');
                InitService.InitializeApplication();
                LogService.SendLogAction({ type: "Login" });

                next({
                    path: '/'
                });

            } else {
                next({
                    path: '/usernotfound'
                });

                localStorage.removeItem('token');
            }

            next();

        }).catch(error => {

            if (error.response.status === 401) {
                window.location.href = window.logoutUrl;
            }
        });*/
    }

    if (localStorage.getItem('token') == null) {

        window.location.href = window.logoutUrl;

        return;
    }

    next();
}); 

// global library setup
Object.defineProperty(Vue.prototype, '$Chartist', {
    get() {
        return this.$root.Chartist
    }
})




/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    async created() {
        await InitService.InitializeApplication();
    },
    methods: {
        async loadCustomBranding() {

            const response = await UserService.GetBrandingForCustomer();

            var branding = response.data;

            document.documentElement.style.setProperty('--pz-iconbox-color', '#F59B00');

            if (branding.logoUrl != undefined && branding.logoUrl != '') {
                document.documentElement.style.setProperty('--pz-logo-image-url', 'url(' + branding.logoUrl + ')')
            } else {
                document.documentElement.style.setProperty('--pz-logo-image-url', 'url(/img/logo-default.png)');
            }

            if (branding.backgroundImageUrl != undefined && branding.backgroundImageUrl != '') {
                document.documentElement.style.setProperty('--pz-background-image-url', 'url(' + branding.backgroundImageUrl + ')')
            } else {
                document.documentElement.style.setProperty('--pz-background-image-url', 'url(/img/background.jpg)')
            }

            if (branding.feedbackLogoUrl != undefined && branding.feedbackLogoUrl != '') {
                document.documentElement.style.setProperty('--pz-fedback-logo-image-url', 'url(' + branding.feedbackLogoUrl + ')')
            } else {
                document.documentElement.style.setProperty('--pz-fedback-logo-image-url', 'url(/img/logo-black.png)')
            }

            Object.keys(branding.cssProperties).forEach(css => {

                document.documentElement.style.setProperty('--' + css, branding.cssProperties[css]);
            });
        }
    }
});
